// extracted by mini-css-extract-plugin
export default {"info-icon":"styles_info-icon__ip7Ls"};